import { useGetDriverFaceClusters } from '@cobliteam/hooks/src/useCamera/useDriverFaceCluster';
import Avatar, { AvatarFallback, AvatarImage } from '@cobliteam/ui/components/Avatar';
import Icon from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

const FaceRecognitionThumbs = () => {
  const { data } = useGetDriverFaceClusters(
    undefined,
    {
      page: 0,
      size: 6,
      sort: undefined,
    },
    false
  );

  const clusters = (data?.content ?? []).filter((cluster): cluster is NonNullable<typeof cluster> => cluster != null);

  return (
    <div className='flex items-center'>
      {clusters
        .sort((_, b) => (b.driver ? -1 : 1))
        .map((cluster, idx) => (
          <Avatar key={cluster.id} className={cn('size-10 border border-white', idx !== 0 && '-ml-3')} style={{ zIndex: clusters.length - idx }}>
            <AvatarImage src={cluster.profileImageUrl?.imageUrl} />
            <AvatarFallback className='bg-primary-12 p-1 text-sidebar-primary-foreground opacity-80'>
              <Icon name='gallery-vertical-end' className='size-3' />
            </AvatarFallback>
          </Avatar>
        ))}
    </div>
  );
};

export default FaceRecognitionThumbs;
